import React, { useState } from 'react';
import { Box, Flex, Heading, HStack, IconButton, Icon, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody } from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import { Link } from "react-router-dom";

const Header = () => {
    const [showNav, setShowNav] = useState(false);

    const handleToggleNav = () => {
        setShowNav(!showNav);
    };

    return (
        <Flex
            as="header"
            align="center"
            justify="space-between"
            wrap="wrap"
            padding="1.5rem"
            bg="teal.500"
            color="white"
            boxShadow="lg"
        >
            <Flex align="center">
                <Heading as="h1" size="lg" letterSpacing={'-.1rem'} mr={8}>
                    Your App Name
                </Heading>
            </Flex>

            <Box display={{ base: 'block', md: 'none' }}>
                <IconButton
                    icon={<Icon as={FiMenu} />}
                    variant="ghost"
                    aria-label="Toggle Navigation"
                    onClick={handleToggleNav}
                />
            </Box>

            
            <HStack spacing={8} display={{ base: 'none', md: 'flex' }}>
                <Link to="/" _hover={{ textDecoration: 'none', color: 'white' }}>
                    Jobs
                </Link>
                <Link to="/applicants" _hover={{ textDecoration: 'none', color: 'white' }}>
                  Applicants
                </Link>
                <Link to="/create-job" _hover={{ textDecoration: 'none', color: 'white' }}>
                    Create Job
                </Link>
                <Link to="/charts" _hover={{ textDecoration: 'none', color: 'white' }}>
                    Charts
                </Link>
            </HStack>

            {/* Navigation Drawer */}
            <Drawer isOpen={showNav} onClose={handleToggleNav} placement="right">
                <DrawerOverlay>
                    <DrawerContent>
                        <DrawerCloseButton />
                        <DrawerHeader>Menu</DrawerHeader>
                        <DrawerBody>
                            <HStack spacing={8} flexDirection="column">
                                <Link to="/" _hover={{ textDecoration: 'none', color: 'white' }}>
                                    Jobs
                                </Link>
                                <Link to="/create-job" _hover={{ textDecoration: 'none', color: 'white' }}>
                                    Create Job
                                </Link>
                                <Link to="/charts" _hover={{ textDecoration: 'none', color: 'white' }}>
                                    Charts
                                </Link>
                            </HStack>
                        </DrawerBody>
                    </DrawerContent>
                </DrawerOverlay>
            </Drawer>
        </Flex>
    );
};

export default Header;
